import {style} from 'typestyle'
import * as csstips from 'csstips'

export const HomeChoiceness = style({
        // paddingTop: 10,
        paddingBottom: 15
})

export const HomeChoicenessWrap = style({
    ...csstips.flexRoot,
    ...csstips.betweenJustified,
    margin: '0px 15px 0px 15px',
    padding: 15,
    boxShadow: '0 5px 8px 0 rgba(51,51,51,0.05)',
    background: '#fff',
    borderRadius: 8,
    $nest: {
        '&:active': {
            background: '#e8e8e8'
        }
    }
})

export const leftModule = style({
    position: 'relative',
    width: '55.73vw',
    maxWidth: 267.52
})

export const bigTitle = style({
    width: '24vw',
    maxWidth: 115,
    marginBottom: 9
})

export const subTitle = style({
        fontSize: 16,
        fontWeight: 500,
        color: '#333333',
        letterSpacing: 0,
        lineHeight: '20px',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        $nest: {
            '@media (max-width: 330px)': {
                fontSize: 14
            }
        }
})

export const content = style({
    position: 'absolute',
    bottom: 0,
    fontSize: 14,
    color: '#999999',
    letterSpacing: 0,
    lineHeight: '20px',
    $nest: {
        '@media (max-width: 330px)': {
            fontSize: 12,
            lineHeight: '15px'
        }
    }
})

export const rightModule = style({
    // marginLeft: 10
})

export const cover = style({
    position: 'relative',
    width: '25.6vw',
    height: '25.6vw',
    maxHeight: 122.88,
    maxWidth: 120.88,
    backgroundSize: 'cover',
    borderRadius: 6,
    cursor: 'pointer',
    $nest: {
        span: {
            position: 'absolute',
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.25)',
            borderRadius: 6
        },
        img: {
            borderRadius: 6
        }
    }
})

export const playBtn = style({
    position: 'absolute',
    right: 5,
    bottom: 5,
    width: '8vw',
    height: '8vw',
    maxWidth: 38.4,
    maxHeight: 38.4
})



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeChoiceness/HomeChoiceness.style.ts